module.exports = __webpack_public_path__ + "static/media/display-1.79f4de35.png";